/**
 * System Templates - Psychology / emotional therapy clinics
 *
 * Read-only treatment-documentation templates for psychology, psychotherapy,
 * emotional therapy, clinical social work and coaching clinics.
 */

const PSYCH_CLINIC_TYPES = [
  "psychology",
  "emotional_therapy",
  "clinical_social_work",
  "personal_coaching",
  "couples_counseling",
];

export const psychologistTemplates = [
  {
    id: "sys_tpl_cbt_session",
    name: "סיכום מפגש CBT",
    fields: [
      { id: "st_cbt_01", type: "radio", label: "מצב רוח בתחילת המפגש (1 = נמוך מאוד, 10 = מצוין)", required: false, options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"] },
      { id: "st_cbt_02", type: "long_text", label: "סקירת משימות הבית מהמפגש הקודם", required: false },
      { id: "st_cbt_03", type: "long_text", label: "סדר יום למפגש (נושאים שנבחרו יחד)", required: true },
      { id: "st_cbt_04", type: "section_header", label: "עבודה על מצב / מחשבה", required: false },
      { id: "st_cbt_05", type: "long_text", label: "המצב / הטריגר", required: false },
      { id: "st_cbt_06", type: "long_text", label: "מחשבה אוטומטית", required: false },
      { id: "st_cbt_07", type: "long_text", label: "רגש ועוצמתו (0–100)", required: false },
      { id: "st_cbt_08", type: "long_text", label: "התנהגות / תגובה", required: false },
      { id: "st_cbt_09", type: "long_text", label: "מחשבה חלופית / מאוזנת", required: false },
      { id: "st_cbt_10", type: "multi_select", label: "טכניקות שתורגלו", required: false, options: ["זיהוי עיוותי חשיבה", "בחינת ראיות", "חשיפה הדרגתית", "הפעלה התנהגותית", "הרפיה / נשימה", "פתרון בעיות", "אחר"] },
      { id: "st_cbt_11", type: "section_header", label: "סיכום", required: false },
      { id: "st_cbt_12", type: "long_text", label: "משימות בית למפגש הבא", required: true },
      { id: "st_cbt_13", type: "radio", label: "מצב רוח בסיום המפגש (1–10)", required: false, options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"] },
      { id: "st_cbt_14", type: "long_text", label: "הערות המטפל/ת", required: false },
    ],
    isSystem: true,
    clinicTypes: PSYCH_CLINIC_TYPES,
  },
];
